import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Row,
  Col,
  Input,
  Label,
} from "reactstrap";
import { Formik, Form } from "formik";
import { validateInit } from "./schema";
import { errorCode } from "../../../utils/constants";
import LoaderUI from "../../../components/common/loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, imageExtension } from "../../../utils/constants";
import { validationMessage } from "../../../utils/validation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { fetchMails } from "../../../context/actions/document";
import { useDispatch } from "react-redux";

toast.configure();

const UnableToIncomeAnalyzer = ({
  currentFile,
  title,
  showModel,
  _toggle,
  addOperator,
  updateOperator,
  operatorDetail,
  disabled,
  locations,
  lodder,
  valiadationData,
  _saveUnableToIncomeAnalyzerJsonData,
  disabledForm,
}) => {
  console.log("currentFile", currentFile);
  let errors = [];
  let [checkboxId, setCheckboxId] = useState([]);
  const dispatch = useDispatch();
  const [contacts, setContacts] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    setCheckboxId([]);
    setContactList([]);
  }, [showModel]);

  useEffect(() => {
    let isCancelled = false;

    if (showModel) {
      dispatch(
        fetchMails({ loanNumber: currentFile.loanNumber }, (res) => {
          if (!isCancelled) {
            if (res.errors) {
              setMsg(res.errors.msg);
            } else if (res.contacts) {
              setContacts(res.contacts);
              setInitiale();
            } else {
              setContacts([]);
            }
          }
        })
      );
    }

    return () => {
      isCancelled = true;
    };
  }, [showModel]);
  let note = "";
  let otherreason = false;
  let notify = false;

  if (currentFile?.unmetDependencies?.length) {
    currentFile.unmetDependencies.forEach((dep) => {
      errors.push({
        code: dep.code,
        detailedErrorMessage: dep.detailedErrorMessage,
        errorMessage: dep.errorMessage,
        level: dep.level,
      });
    });
  }

  const [payload, setPlayload] = useState({
    ...validateInit,
  });

  const setInitiale = () => {
    let obj = {};
    contacts.forEach((contact, i) => {
      obj[`notify_${i}`] = false;
    });

    setPlayload((prevValue) => ({ ...prevValue, ...obj }));
  };

  /**
   * @description method use to add operator
   * @param {object} params form params
   * @param {Instance} status form status/valiations err
   */
   const submitForm = (params, status) => {
    // Extract selected errors from checkboxId
    let selectedErrors = checkboxId.map((checkbox) => ({
      errorCode: checkbox.errorCode,
      errorMessage: checkbox.errorMessage,
      detailedErrorMessage: checkbox.detailedErrorMessage,
    }));


    // Validate form inputs
    if (!(selectedErrors.length || params?.otherreason)) {
      toast.error("Please check any reason", toasterConfig);
      return;
    } else if (params?.otherreason && !params.note.trim().length) {
      toast.error("Additional information cannot be empty", toasterConfig);
      return;
    }
    let shouldNotify = contactList.length > 0;
    // Construct userValidation object
    let userValidation = {
      isRejected: true,
      rejectionTrigger:"button_click",
      rejected: {
        note: params.note,
        notify: shouldNotify,
        timestamp: new Date().toISOString(),
        errors: selectedErrors,
      },
    };
  
    // Determine notifyContact based on contactList
    if (contactList.length > 0) {
      userValidation.rejected.notifyContact = contactList.map((contact) => ({
        email: contact.email,
      }));
    }
  
    // Construct payload object
    let payload = {
      loanNumber: currentFile?.loanNumber,
      moriIrsIncomeId: currentFile?.moriIrsIncomeId,
      borrowerLosId: currentFile?.borrowerLosId,
      incomeSource:currentFile?.incomeSource ? currentFile?.incomeSource : '',
      receivedDependencies: currentFile?.receivedDependencies,
      unmetDependencies: currentFile?.unmetDependencies,
      status: currentFile?.status,
      userValidation: userValidation,
    };
  
    console.log("payload", JSON.stringify(payload, null, 2));
    _saveUnableToIncomeAnalyzerJsonData(payload)
  };
  

  const checkUncheckErrors = (val, index, item) => {
    if (val) {
      if (
        checkboxId.findIndex(
          (cur) =>
            (cur?.detailedErrorMessage === item?.detailedErrorMessage && cur?.errorCode == item?.code) == -1
        )
      ) {
        setCheckboxId((prev) => [
          ...prev,
          {
            errorCode: item?.code,
            errorMessage: item?.errorMessage,
            detailedErrorMessage: item?.detailedErrorMessage
          },
        ]);
      }
    } else {
      let i = checkboxId.findIndex(
        (cur) => cur?.detailedErrorMessage === item?.detailedErrorMessage && cur?.errorCode == item?.code
      );
      if (i !== -1) {
        checkboxId.splice(i, 1);
        setCheckboxId((prev) => (prev = checkboxId));
      }
    }

    // console.log('setCheckboxId', checkboxId)
  };

  /**
   * @description method use to close add operator modal
   */
  const toggle = () => {
    _toggle();
    setContacts([])
    setMsg("")
  };

  return (
    <>
      <Modal
        isOpen={showModel}
        toggle={toggle}
        backdrop="static"
        className="validate-modal"
      >
        <Formik
          initialValues={payload}
          enableReinitialize
          onSubmit={submitForm}
        >
          {(formik) => (
            <Form>
              <ModalHeader>
                {title}
                <Button color="link" onClick={toggle}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                  >
                    <g data-name="Group 651" transform="translate(-1535 -134)">
                      <g
                        fill="#fff"
                        stroke="#000"
                        strokeWidth="2"
                        data-name="Ellipse 30"
                        opacity="0.3"
                        transform="translate(1535 134)"
                      >
                        <circle cx="17" cy="17" r="17" stroke="none"></circle>
                        <circle cx="17" cy="17" r="16" fill="none"></circle>
                      </g>
                      <path
                        d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                        data-name="Icon ionic-ios-close"
                        opacity="0.3"
                        transform="translate(1534.289 132.789)"
                      ></path>
                    </g>
                  </svg>
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className="row">
                  {errors.map((item, index) => {
                    return (
                      <div className="col-sm-12 validation-error-list">
                        <Label className="">
                          <Input
                            type="checkbox"
                            name="error"
                            disabled={disabledForm}
                            // defaultChecked={item?.defaultChecked}
                            onChange={(e) => {
                              formik.setFieldValue("error", e.target.checked);
                              checkUncheckErrors(e.target.checked, index, item);
                            }}
                          />
                          <span className="txt">
                            <strong>{item?.detailedErrorMessage}</strong>
                          </span>
                        </Label>
                      </div>
                    );
                  })}
                </div>
                <div className="col-sm-12 other-reason-rw">
                  <Label className="">
                    <Input
                      type="checkbox"
                      name="otherreason"
                      disabled={disabledForm}
                      defaultChecked={false || otherreason}
                      onChange={(e) => {
                        formik.setFieldValue("otherreason", e.target.checked);
                        if (!e.target.checked) {
                          formik.setFieldValue("note", "");
                        }
                      }}
                    />
                    <span className="txt">{"Other reason"}</span>
                  </Label>
                  {formik?.values?.otherreason || otherreason ? (
                    <Col sm="12" className="add-info">
                      <Label>{"Additional information"}</Label>
                      <Input
                        type="textarea"
                        name="note"
                        disabled={disabledForm}
                        value={formik?.values?.note || note}
                        onChange={formik.handleChange}
                      />
                    </Col>
                  ) : (
                    ""
                  )}
                </div>
                <div className="loan-contacts-list">
                  <h3>Select Loan Contacts to Notify:</h3>
                  {msg && <span className="txt">{msg}</span>}
                  <div className="list-items d-flex flex-wrap">
                    {contacts &&
                      contacts.map((contact, i) => {
                        return (
                          <>
                            <Label key={i} className="">
                              <Input
                                type="checkbox"
                                name={`notify_${i}`}
                                // defaultChecked={notify ? true : false}
                                checked={formik.values[`notify_${i}`]}
                                disabled={disabledForm}
                                onChange={(e) => {
                                  if (!e.target.checked) {
                                    formik.setFieldValue('notify', false); 
                                    formik.setFieldValue(`notify_${i}`, false); 
                                    setContactList(prevValue => prevValue.filter(c => c.email !== contact.email));
                                  }else{
                                    formik.setFieldValue(`notify_${i}`, e.target.checked);
                                    setContactList((prevValue) => ([ ...prevValue, { email: contact.email } ]));
                                    if(contacts.length === (contactList.length+1)){
                                      formik.setFieldValue('notify', true); 
                                    }
                                  }
                                }}
                              />
                              <span className="txt">
                                {contact.role} : {contact.email}
                              </span>
                            </Label>
                          </>
                        );
                      })}
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Label className="notify-cell">
                  <Input
                    type="checkbox"
                    name="notify"
                    defaultChecked={notify ? true : false}
                    checked={formik.values[`notify`]}
                    disabled={disabledForm}
                    onChange={(e) => {
                      formik.setFieldValue("notify", e.target.checked);
                      if (e.target.checked) {
                        contacts.forEach((contact, i) => {
                          formik.setFieldValue(`notify_${i}`, true);
                          setContactList((prevValue) => [
                            ...prevValue,
                            { email: contact.email },
                          ]);
                        });
                      } else {
                        contacts.forEach((contact, i) => {
                          formik.setFieldValue(`notify_${i}`, false);
                          setContactList([]);
                        });
                      }
                    }}
                  />
                  <span className="txt">{"Notify all contacts"}</span>
                </Label>

                <Button color="link" onClick={toggle} className="cancel-btn">
                  Cancel
                </Button>
                <Button
                  disabled={disabled || disabledForm}
                  color="secondary"
                  type="submit"
                >
                  {"Submit"}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default UnableToIncomeAnalyzer;
